"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logEventLoopLag = logEventLoopLag;
var _browserLogs = require("@datadog/browser-logs");
/**
 * Monitors and logs browser event loop lag using a recurring timer.
 *
 * This function tracks the time it takes for the event loop to execute
 * a scheduled callback, compared to the intended interval. If the lag
 * exceeds a defined threshold, it logs the lag to Datadog.
 *
 * The event loop lag occurs when the browser main JavaScript event loop is busy and unable
 * to execute scheduled callbacks in time. This can be caused by:
 *   - Long-running synchronous tasks
 *   - Heavy rendering or computation
 *   - Resource contention
 *
 * ┌───────────────┐               ┌───────────────┐
 * │ Timer Started │   Interval    │ Timer Fired   │
 * │ (setTimeout)  │──────────────▶│ (Callback)    │
 * └───────────────┘               └───────────────┘
 *                             ▲
 *                             │ Lag (if other tasks block the thread)
 *
 * - `performance.now()`: Provides a high-resolution timestamp in milliseconds.
 * - `setTimeout`: Schedules a callback after a fixed interval.
 * - Lag Calculation: (Current time - Last recorded time) - Interval
 *
 * Example:
 * --------
 * Assuming the interval is 2000ms:
 * - Expected time to fire: 2000ms
 * - Actual time to fire: 2320ms
 * - Calculated lag: 320ms
 *
 * If lag exceeds the threshold (50ms in this example), the function logs the
 * event loop lag to Datadog.
 *
 * Timeline:
 *
 * ┌────────┬───────────────────────┬────────┬───────────────────────┐
 * │ Start  │  Scheduled (2000ms)   │ Lag    │ Actual Execution Time │
 * │ Time   │                       │ (320ms)│                       │
 * │ 0ms    │----------------------▶│-------▶│ 2320ms                │
 * └────────┴───────────────────────┴────────┴───────────────────────┘
 *
 * ------------------------
 * 1. A timer (`setTimeout`) is initialized with an interval of 2000ms.
 * 2. In each callback:
 *    - The current timestamp is recorded.
 *    - The lag is calculated as: `currentTime - lastTime - interval`.
 *    - If lag exceeds the threshold, the event is logged to Datadog.
 * 3. The next timer is scheduled recursively to continue monitoring.
 */

function logEventLoopLag() {
  var messageContext = {
    logger: {
      name: 'studio-event-loop-lag'
    }
  };
  var interval = 2000;
  var threshold = 50;
  var lastTime = performance.now();
  function checkLag() {
    var currentTime = performance.now();
    var lag = currentTime - lastTime - interval;
    if (lag >= threshold) {
      var lagRounded = parseFloat(lag.toFixed(1));
      messageContext['lag'] = lagRounded;
      var message = "Event loop lag reached ".concat(lagRounded, " ms");
      _browserLogs.datadogLogs.logger['info'](message, messageContext);
    }
    lastTime = currentTime;
    setTimeout(checkLag, interval); // Schedule the next check
  }

  // Start monitoring
  setTimeout(checkLag, interval);
}